import React from "react";
import Current from "./Current";
// import Previous from "./Previous";
export default function Administrators() {

    return (
        <div className={'flex flex-col gap-3'}>
            <Current/>
            {/*<Previous/>*/}
        </div>
    )
}
